import AccettazioneAbruzzoList from "./pages/AccettazioneAbruzzoList.vue";
import AccettazioneAbruzzoEdit from "./pages/AccettazioneAbruzzoEdit.vue";
import AccettazioneAbruzzoView from "./pages/AccettazioneAbruzzoView.vue";

export default {
    AccettazioneAbruzzoList,
    AccettazioneAbruzzoEdit,
    AccettazioneAbruzzoView,
};
